import * as Migration from 'shared/migration/migration';
import { Conversion } from 'shared/migration/migration';

type LegacyFlow = Record<string, any>;

const conversions: Conversion<LegacyFlow>[] = [
  { version: '1', rules: [{ isSuitable: () => true, migrateUp: v0tov1 }] },
];

export const CURRENT_VERSION = '1';

export function migrateToTheLatest(flows: LegacyFlow[]) {
  return Migration.migrateToTheLatest(flows, conversions);
}


function v0tov1(flow: LegacyFlow): LegacyFlow {
  flow.options.flowsteps ??= [];
  return flow;
}
